import { z } from 'zod';
import { Currency } from '@40seas/models';
import { InvoiceStatus } from '@40seas/entities/invoices';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { CheckoutResult, CheckoutResultSchema, CheckoutStatus } from '@40seas/entities/checkout';
import { PaymentMethodProviderType } from '@40seas/entities/payment-methods';
import { FundsMatchingMethod } from './funds.matching-method.enum';

export const MatchingBuyerSchema = z.object({
    id: z.string(),
    reference: z.string().nullish(),
    legalName: z.string().nullish(),
    displayName: z.string().nullish(),
    externalId: z.string().nullish(),
});

export class MatchingBuyer extends FromSchema(MatchingBuyerSchema) {
    id: string;
    reference?: string;
    legalName?: string;
    displayName?: string;
    externalId?: string;
}

export const MatchingPaymentMethodSchema = z.object({
    id: z.string(),
    providerId: z.string(),
    providerType: EnumSchema(PaymentMethodProviderType),
});

export class MatchingPaymentMethod extends FromSchema(MatchingPaymentMethodSchema) {
    id: string;
    providerId: string;
    providerType: PaymentMethodProviderType;
}

export const MatchingInvoiceSchema = z.object({
    id: z.string(),
    status: EnumSchema(InvoiceStatus),
    amount: z.number(),
    currency: EnumSchema(Currency),
    externalId: z.string().optional(),
});

export class MatchingInvoice extends FromSchema(MatchingInvoiceSchema) {
    id: string;
    status: InvoiceStatus;
    amount: number;
    currency: Currency;
    externalId?: string;
}

export const MatchingCheckoutSchema = z.object({
    id: z.string(),
    status: EnumSchema(CheckoutStatus),
    result: CheckoutResultSchema.nullish(),
    amount: z.number().optional(),
    currency: EnumSchema(Currency),
    reference: z.string().optional(),
    externalId: z.string().optional(),
});

export class MatchingCheckout extends FromSchema(MatchingCheckoutSchema) {
    id: string;
    status: CheckoutStatus;
    result?: CheckoutResult;
    amount?: number;
    currency: Currency;
    reference?: string;
    externalId?: string;
}

export const FundsMatchingDetailsSchema = z.object({
    matchingBuyers: z.array(MatchingBuyerSchema).optional(),
    matchingInvoices: z.array(MatchingInvoiceSchema).optional(),
    matchingCheckouts: z.array(MatchingCheckoutSchema).optional(),
    matchingPaymentMethods: z.array(MatchingPaymentMethodSchema).optional(),
});

export class FundsMatchingDetails extends FromSchema(FundsMatchingDetailsSchema) {
    matchingBuyers?: MatchingBuyer[];
    matchingInvoices?: MatchingInvoice[];
    matchingCheckouts?: MatchingCheckout[];
    matchingPaymentMethods?: MatchingPaymentMethod[];
}

export const BuyerMatchingReferenceSchema = z.object({
    id: z.string(),
    matchingMethod: EnumSchema(FundsMatchingMethod),
    confidenceScore: z.number(),
});

export class BuyerMatchingReference extends FromSchema(BuyerMatchingReferenceSchema) {
    id: string;
    matchingMethod: FundsMatchingMethod;
    confidenceScore: number;
}
